import React, { useState } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
//import { DateTimePicker } from "@material-ui/pickers";
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
//import { DateTimePicker } from '@mui/lab';
import { Paper, Grid, Typography, ButtonGroup, Button } from '@mui/material';

import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { assetNamesSelector } from '../../features/assets/assetsSlice';
import { eventCollection } from '../../utils/eventTypes';
import { distancePeriodsMain, getperiod } from '../../utils/datePeriodCalculator';
import { searchEventsMulti, setViewType } from '../../features/events/eventsSlice';


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 200,
    },
    selectEmpty: {
        marginTop: useTheme().spacing(2),
    },
}));

const EventSearchBox = ({ searchModalOpen, handleSearchModalClose }) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const assetNames = useSelector(assetNamesSelector);
    const assetOptions = assetNames ? Object.keys(assetNames) : [];
    assetOptions.push("");


    const [vehicle, setVehicle] = useState("");
    const [assetId, setAssetId] = useState("");

    const [eventType, setEventType] = useState('');
    const [periodType, setPeriodType] = useState('today');

    const [fromDate, setFromDate] = useState(getperiod(periodType).fromDate);
    const [toDate, setToDate] = useState(getperiod(periodType).toDate);

    const onVehicleSelect = (e, newValue) => {
        //console.log('Vehicle seletced', newValue);
        setVehicle(newValue);
    }

    const onAssetIdChange = (e, newValue) => {
        //console.log("AssetID changed", newValue);
        setAssetId(newValue);
    }

    const onPeriodChange = (e) => {
        //console.log("New Peiord", e.target.value);
        setPeriodType(e.target.value);
        if (e.target.value !== "custom") {
            const { fromDate, toDate } = getperiod(e.target.value);
            setFromDate(fromDate);
            setToDate(toDate);
        }
    }

    const onFromDateChange = (value) => {
        setFromDate(value);
        setPeriodType("custom");
    }

    const onToDateChange = (value) => {
        setToDate(value);
        setPeriodType("custom");
    }

    const onSearch = () => {
        let searchParam = {
            fromDate: moment(fromDate).format('YYYY-MM-DD HH:mm:ss'),
            toDate: moment(toDate).format('YYYY-MM-DD HH:mm:ss'),
            limit: 25,
            offset: 0,
            vehicleName: vehicle,
            eventDesc: eventType,
        };
        dispatch(searchEventsMulti(searchParam));
        dispatch(setViewType('search'));
        handleSearchModalClose();
    }

    if (!assetNames) {
        return null;
    } else {
        return (
            <Modal
                open={searchModalOpen}
                onClose={handleSearchModalClose}
            >

                <div style={dimentions.mapModal}>
                    <Paper>
                        <div style={{
                            marginTop: '15px', marginBottom: '5px', marginLeft: '15px', width: '250px'
                        }}>
                            <Grid container spacing={1} alignItems="flex-end">
                                <Grid item sm={12}>
                                    <Typography variant="h6">
                                        <b>Search Events</b>
                                    </Typography>
                                </Grid>

                                <Grid item sm={12}>
                                    <FormControl className={classes.formControl}>
                                        <Autocomplete
                                            id="vehicle"
                                            style={{ width: 200 }}
                                            options={assetOptions}
                                            getOptionLabel={(option) => option ? assetNames[option].regn : ""}
                                            value={assetId}
                                            onChange={onAssetIdChange}
                                            inputValue={vehicle}
                                            onInputChange={onVehicleSelect}
                                            renderInput={(params) => <TextField variant="standard" {...params} label="Vehicle" />}
                                        />
                                    </FormControl>

                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel id="eventColletionLabel">Event Type</InputLabel>
                                        <Select
                                            variant="standard"
                                            labelId="eventColletionLabel"
                                            id="eventCollectionSelect"
                                            value={eventType}
                                            onChange={(e) => setEventType(e.target.value)}
                                        >
                                            {
                                                eventCollection.map(ev => <MenuItem key={ev} value={ev}>{ev}</MenuItem>)
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel id="periodTypeLabel">Peiod Type</InputLabel>
                                        <Select
                                            variant="standard"
                                            labelId="periodTypeLabel"
                                            id="peiodTypeSelect"
                                            value={periodType}
                                            onChange={onPeriodChange}
                                        >
                                            {
                                                distancePeriodsMain.map(ev => <MenuItem key={ev.value} value={ev.value}>{ev.name}</MenuItem>)
                                            }
                                            <MenuItem key={"custom"} value={"custom"}>{"Custom"}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl className={classes.formControl}>
                                        <DesktopDateTimePicker
                                            autoOk
                                            ampm={true}
                                            disableFuture
                                            value={fromDate}
                                            onChange={onFromDateChange}
                                            renderInput={(props) => <TextField variant="standard" label="Period From" {...props} />}
                                            format="Do MMM YY h:mm a"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl className={classes.formControl}>

                                        <DesktopDateTimePicker
                                            autoOk
                                            ampm={true}
                                            disableFuture
                                            value={toDate}
                                            onChange={onToDateChange}
                                            renderInput={(props) => <TextField variant="standard" label="Period To" {...props} />}
                                            format="Do MMM YY h:mm a"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl className={classes.formControl}>
                                        <ButtonGroup color="primary" variant="outlined">
                                            <Button
                                                onClick={handleSearchModalClose}
                                                color="secondary"
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                onClick={onSearch}
                                            >
                                                Search
                                            </Button>
                                        </ButtonGroup>

                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div>


                    </Paper>
                </div>
            </Modal>
        );
    }
}

export default EventSearchBox;